export const Urls = {
    GetLookup: "lookup/GetLookup",
    GetTableMetaDatas: "lookup/GetTableMetadata",
    GetTableColumnMetaDatas: "lookup/GetTableColumnMetadata",
    UpdateLookupValues: "lookup/UpdateLookupValues",
    UpdateLookupsOrdering: "lookup/UpdateLookupsOrdering",
    ClearCache: "LookupCache/Cache",
}

export const LookupAdditionalData = {
    parentId: "parentId",
    isActive: "isActive",
    isSelectable: "isSelectable",
    code: "code",
    isForAccept: "isForAccept",
    visibleForScopes: "visibleForScopes",
    scope: "scope"
}

export const GenesisLookups = {
    "branches": "branches",
    "departments": "departments",
    "roles": "roles",
    "users": "users",
    "workflowReasons": "workflowReasons",
    "entityTypes" : "entityTypes",
    "countries": "countries"
}

export const CacheCategory = {
    lookups: "lookups"
}